import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCurrentBreakpoint } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { Button } from '../../../../../../components/UpliftAds/components/Banner/components/Hero/components/Button.js';
import { Container } from '../../../../../../components/UpliftAds/components/Banner/components/Hero/components/Container.js';
import { Content } from '../../../../../../components/UpliftAds/components/Banner/components/Hero/components/Content.js';
import { Headline } from '../../../../../../components/UpliftAds/components/Banner/components/Hero/components/Headline.js';
import { Image } from '../../../../../../components/UpliftAds/components/Banner/components/Hero/components/Image.js';
import { Logo } from '../../../../../../components/UpliftAds/components/Banner/components/Hero/components/Logo.js';
import { LabelMedium, Stack } from '../../../../../../primitives/index.js';
export const Hero = ({
  title,
  subtitle,
  image,
  logo
}) => {
  const {
    t
  } = useTranslation('upliftAds');
  const currentScreen = useCurrentBreakpoint();
  const linesToTruncate = {
    xs: 2,
    sm: 2,
    md: 1,
    lg: 2,
    xl: false
  }[currentScreen];
  return _jsxs(Stack, {
    spacing: "small",
    children: [_jsx(LabelMedium, {
      color: "contentSecondary",
      children: t('label')
    }), _jsxs(Container, {
      spacing: "none",
      children: [_jsxs(Content, {
        direction: "column",
        justifyContent: "center",
        spacing: "medium",
        children: [_jsxs(Stack, {
          spacing: "small",
          children: [_jsx(Headline, {
            color: "contentInversePrimary",
            children: title
          }), _jsx(LabelMedium, {
            color: "contentInversePrimary",
            truncate: linesToTruncate,
            children: subtitle
          })]
        }), _jsx(Button, {
          variant: "danger",
          children: t('button')
        })]
      }), _jsx(Image, {
        src: image,
        alt: ""
      }), logo && _jsx(Logo, {
        src: logo,
        alt: ""
      })]
    })]
  });
};